import { type ReactNode, useContext } from "react";
import { FontSizeContext } from "src/context/FontSizeContext";

import useLocalStorage from "./useLocalStorage";

export const fontSizes = ["12", "14", "16", "18"];

export function FontSizeProvider({ children }: { children: ReactNode }) {
	const [fontSize, setFontSize] = useLocalStorage("font-size", "14");
	const fontSizeClass = `size-${fontSize}-light`;
	const fontSizeNormalClass = `size-${fontSize}`;
	const fontSizeBoldClass = `size-${fontSize}-bold`;
	const fontSizeDeepClass = `size-${fontSize}-deep`;
	// Modale: treść = font + 2px, nagłówek = font + 4px (max 22).
	const modalTextFontSizeClass = `size-${Number(fontSize) + 2}-light`;
	const modalHeaderFontSizeClass = `size-${Number(fontSize) + 4}`;
	// Tytuł modala (ModalHeader) = font + 8px.
	const modalTitleFontSizeClass = `size-${Number(fontSize) + 8}`;

	const getFontSizeClass = (diff: number) => {
		const index = fontSizes.indexOf(String(fontSize));

		if (index === -1) {
			return fontSize;
		}

		const newFontIndex = index + diff;
		const font = fontSizes[newFontIndex];

		if (font) {
			return `size-${font}-light`;
		}

		if (newFontIndex > index) {
			return `size-${fontSizes[fontSizes.length - 1]}-light`;
		}

		if (newFontIndex < index) {
			return `size-${fontSizes[0]}-light`;
		}

		return fontSize;
	};

	const contextValue = {
		fontSize,
		setFontSize,
		fontSizeClass,
		fontSizeNormalClass,
		fontSizeBoldClass,
		fontSizes: String(fontSize),
		getFontSizeClass,
		fontSizeDeepClass,
		modalTextFontSizeClass,
		modalHeaderFontSizeClass,
		modalTitleFontSizeClass,
	};

	return (
		<FontSizeContext.Provider value={contextValue}>
			{children}
		</FontSizeContext.Provider>
	);
}

export const useFontSize = () => {
	return useContext(FontSizeContext);
};

if (import.meta.env.DEV && import.meta.hot) {
	import.meta.hot.invalidate();
}
